import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Header from '../InitialPage/Sidebar/Header';
import Sidebar from '../InitialPage/Sidebar/Sidebar';

export default function HeaderLayouts() {
  const [collapsed, setCollapsed] = useState(false);
  const [compact, setCompact] = useState(() => window.matchMedia("(max-width: 1023px)").matches);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { pathname } = useLocation();
  const { t } = useTranslation();
  useEffect(() => { setDrawerOpen(false); window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    const query = window.matchMedia('(max-width: 1023px)');
    const update = () => { setCompact(query.matches); if (!query.matches) setDrawerOpen(false); };
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  const toggleNavigation = () => {
    if (compact) setDrawerOpen(true);
    else setCollapsed(value => !value);
  };
  return <div className={`ui-shell ${collapsed ? 'ui-shell-collapsed' : ''}`}>
    <a className="ui-skip-link" href="#main-content">{t('ui.skipContent')}</a>
    <aside className="ui-desktop-sidebar"><Sidebar collapsed={collapsed} /></aside>
    <Offcanvas show={drawerOpen} onHide={() => setDrawerOpen(false)} className="ui-nav-drawer" aria-labelledby="navigation-title">
      <Offcanvas.Header closeButton closeLabel={t('close')}><Offcanvas.Title id="navigation-title">{t('ui.navigation')}</Offcanvas.Title></Offcanvas.Header>
      <Offcanvas.Body><Sidebar onNavigate={() => setDrawerOpen(false)} /></Offcanvas.Body>
    </Offcanvas>
    <Header onToggleNavigation={toggleNavigation} navigationExpanded={compact ? drawerOpen : !collapsed} />
    <main id="main-content" tabIndex={-1} className="ui-main"><Outlet /></main>
  </div>;
}
